import { z } from 'zod'

import { InvoiceForm } from '@features/invoices/types/invoiceForm/invoiceForm'

import { DemoInvoiceFormSchema } from '../types/demoInvoiceFormSchema'

export const demoInvoiceFormSchema: DemoInvoiceFormSchema = z.custom<InvoiceForm>()
